module.exports = {template: '<svg viewBox="0 0 31.5 56"><path fill="#fff" d="M.8 26.1c-1.1 1-1.1 2.7 0 3.8l26 25.3c1 1.1 2.7 1.2 3.9.2 1.1-1 1.2-2.7.2-3.8l-.2-.2L9.4 30.6 6.8 28l2.6-2.7L30.6 4.6c.5-.5.8-1.2.9-1.9 0-1.5-1.2-2.7-2.7-2.7-.7 0-1.5.3-2 .8L.8 26.1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icons/arrow_prev.svg
// module id = 654
// module chunks = 1